import { __t, applyTranslations } from 'utils/language';
import { CREATE, DELETE, DUPLICATE, REPORT } from 'modules/insights/sov/utils/sov';

import type { SOVGeneralProps, SOVReportType } from 'modules/insights/sov/types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./sov-report-modal.i18n.json'));

const COLLABARY_MSG_KEY = 'collabary_common';
const MSG_KEY = 'sov_reports';

export function getModalTitle(type: string, reportType: SOVReportType): string {
  return __t(`${MSG_KEY}.modal.title_${type}`, {
    reportType: __t(`${COLLABARY_MSG_KEY}.social.${reportType}`)
  });
}

export function getModalButtonText(type: string): string {
  return __t(`${MSG_KEY}.buttons.${type}`);
}

export function getModalLabels(type: string): SOVGeneralProps {
  if (type === CREATE || type === DUPLICATE) {
    return {
      name: __t(`${MSG_KEY}.labels.report_name`),
      description: __t(`${MSG_KEY}.labels.description`),
      actionButton: getModalButtonText(type === CREATE ? CREATE : 'save')
    };
  }

  return {
    actionButton: getModalButtonText(DELETE)
  };
}

export function getCommonModalProps(type: string, reportType: SOVReportType): SOVGeneralProps {
  return {
    title: getModalTitle(type, reportType),
    labels: getModalLabels(type),
    placeholders: {
      name: __t(`${MSG_KEY}.placeholders.add_name`),
      description: __t(`${MSG_KEY}.placeholders.describe_report`)
    },
    sectionType: REPORT,
    reportType,
    actionType: type
  };
}
